import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import { useDispatch, useSelector } from "react-redux";
import ImagePicker from "components/ApnaUploader";
import { Cancel } from "@mui/icons-material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import MDInput from "components/MDInput";
import { Card } from "@mui/material";
import { getAllBlogs } from "redux/festures/blogSlice";
import { updateBlog } from "redux/festures/blogSlice";
import { createPostBlogs } from "redux/festures/blogSlice";
import { handleAlert } from "redux/festures/alertSlice";
import Skeditor, { convertContentToHTML as skConvertContentToHTML } from "components/SKeditor";
import { EditorState } from "draft-js";
import AstrieskIcon from "components/AstrieskIcon";
import MultiInput from "components/MultiInput";

const Form = ({ isOpenUpdate, setIsOpenUpdate, setIsOpen }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [isData, setIsData] = useState({
    title: "",
    description: EditorState.createEmpty(),
    image: null,
    metaTitle: "",
    metaDescription: "",
    metaKeywords: [""],
  });
  const [isShow, setIsShow] = useState("");
  //   const [isBrandShowHome, setIsBrandShowHome] = useState(false);
  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const { Loading, singleBlogs } = useSelector((data) => data?.isBlogs) || {};
  // console.log(singleBrands, "singleBrands");
  useEffect(() => {
    if (singleBlogs && isOpenUpdate) {
      setIsData({
        title: singleBlogs?.title || "",
        description: EditorState.createEmpty(),
        image: singleBlogs?.image || null,
        metaTitle: singleBlogs?.meta?.title || "",
        metaDescription: singleBlogs?.meta?.description || "",
        metaKeywords: singleBlogs?.meta?.keywords || [],
      });
      // setIsBlogContent(singleBlogs?.description);
    }
  }, [singleBlogs, isOpenUpdate]);
  // console.log(singleBlogs);
  const handleFormSubmit = (e) => {
    e.preventDefault();
    if ((isData?.image && isData?.image !== "") || (isShow && isShow !== "")) {
      const convertContentToHTML = () => {
        return skConvertContentToHTML(isData?.description);
      };
      if (isOpenUpdate) {
        const formData = new FormData();
        formData.append("title", isData?.title);
        formData.append("description", convertContentToHTML());
        formData.append("image", isData?.image);
        formData.append("metaTitle", isData?.metaTitle);
        formData.append("metaDescription", isData?.metaDescription);
        isData?.metaKeywords?.map((e, i) => formData.append(`metaKeywords[${i}]`, e));
        formData.append("blogId", singleBlogs?._id);
        dispatch(
          updateBlog({
            url: `${process.env.REACT_APP_API}/updateBlog`,
            data: formData,
          })
        ).then((data) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: `${data?.payload?.success ? "success" : "error"}`,
              msg: data?.payload?.message,
            })
          );
          setIsData({
            title: "",
            description: EditorState.createEmpty(),
            image: null,
            metaTitle: "",
            metaDescription: "",
            metaKeywords: [],
          });
          setIsOpen(false);
          setIsOpenUpdate(false);
          dispatch(getAllBlogs(`/getBlog?adminId=${admin}`));
        });
      } else {
        const formData = new FormData();
        formData.append("title", isData?.title);
        formData.append("description", convertContentToHTML());
        formData.append("image", isData?.image);
        formData.append("metaTitle", isData?.metaTitle);
        formData.append("metaDescription", isData?.metaDescription);
        isData?.metaKeywords?.map((e, i) => formData.append(`metaKeywords[${i}]`, e));
        dispatch(
          createPostBlogs({
            url: `${process.env.REACT_APP_API}/createBlog`,
            data: formData,
          })
        ).then((data) => {
          dispatch(
            handleAlert({
              isOpen: true,
              type: `${data?.payload?.success ? "success" : "error"}`,
              msg: data?.payload?.message,
            })
          );
          setIsOpen(false);
          setIsOpenUpdate(false);
          setIsData({
            title: "",
            description: EditorState.createEmpty(),
            image: null,
            metaTitle: "",
            metaDescription: "",
            metaKeywords: [],
          });
          dispatch(getAllBlogs(`/getBlog?adminId=${admin}`));
        });
      }
    } else {
      dispatch(
        handleAlert({
          isOpen: true,
          type: "warning",
          msg: "plz fill all input",
        })
      );
    }
  };

  return Loading ? (
    <SkLoading />
  ) : (
    <>
      <MDBox
        display="flex"
        alignItems="center"
        lineHeight={1}
        sx={{
          justifyContent: "center",
          textAlign: "center",
          flexDirection: "column",
          gap: 5,
          width: "100%",
        }}
      >
        <Card
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 , 10px",
          }}
        >
          <MDTypography variant="h6" py={0.9}>
            {isOpenUpdate ? `Update Blog ` : " Create Blog"}
          </MDTypography>
        </Card>
        <MDBox
          display="flex"
          alignItems="center"
          lineHeight={1}
          //   sx={{
          //
          //   }}
          sx={({ palette: { dark, white, info } }) => ({
            border: 0.5,
            borderColor: darkMode ? white.main : dark.main,
            borderRadius: 3,
            p: 3,
            justifyContent: "center",
            textAlign: "center",
            flexDirection: "column",
            gap: 3,
            width: "100%",
          })}
          component="form"
          role="form"
          onSubmit={handleFormSubmit}
        >
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Blog Title <AstrieskIcon />
            </MDTypography>
            <MDInput
              required={true}
              type="text"
              placeholder="Blog Title"
              fullWidth
              name="Blog Title"
              value={isData?.title}
              onChange={(e) => setIsData((prev) => ({ ...prev, title: e.target.value }))}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Blog description <AstrieskIcon />
              <MDTypography variant="body1" component="span" fontSize={11}>
                &nbsp; ( type only English language )
              </MDTypography>
            </MDTypography>
            {/* <MDInput
              type="text"
              placeholder="content"
              fullWidth
              name="content"
              value={isBlogContent}
              onChange={(e) => setIsBlogContent(e.target.value)}
            /> */}

            <Skeditor
              editorState={isData?.description}
              setEditorState={(e) =>
                setIsData((prev) => ({ ...prev, description: e || EditorState.createEmpty() }))
              }
              placeholder={"Blog Content"}
              initialContent={singleBlogs && isOpenUpdate && singleBlogs?.description}
              isButton={true}
              // content={"Blog Content"}
              required={true}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Blog Image{" "}
              <MDTypography variant="body1" component="span" fontSize={11}>
                &nbsp; ( image size - 240 × 240 px )
              </MDTypography>
            </MDTypography>
            <ImagePicker
              // required={true}
              name="Blog Image"
              multiple={false}
              images={isData?.image}
              setImages={(e) => setIsData((prev) => ({ ...prev, image: e }))}
              //
            />

            {isData?.image && isData?.image.length
              ? null
              : isShow && (
                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <span
                      style={{
                        display: "inline-block",
                        width: "50px",
                        height: "50px",
                        margin: "0 0.5rem",
                      }}
                    >
                      <img
                        className="Image"
                        style={{ width: "100%", height: "100%" }}
                        src={`${isShow}`}
                      />
                    </span>
                    <span
                      className="cross"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setIsShow(null);
                      }}
                    >
                      <Cancel
                        sx={({ palette: { dark, white, info } }) => ({
                          color: darkMode ? white?.main : dark.main,
                        })}
                      />
                    </span>
                  </div>
                )}
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Meta Title <AstrieskIcon />
            </MDTypography>
            <MDInput
              // disabled={createUpdateLoading}
              required={true}
              type="text"
              placeholder="Meta Title"
              fullWidth
              name="metaTitle"
              value={isData?.metaTitle}
              onChange={(e) => setIsData((prev) => ({ ...prev, metaTitle: e.target.value }))}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"90%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <MDTypography variant="h6">
              Meta Description <AstrieskIcon />
            </MDTypography>
            <MDInput
              // disabled={createUpdateLoading}
              required={true}
              type="text"
              placeholder="Meta Description"
              fullWidth
              name="metaDescription"
              value={isData?.metaDescription}
              onChange={(e) => setIsData((prev) => ({ ...prev, metaDescription: e.target.value }))}
            />
          </MDBox>
          <MDBox
            lineHeight={1}
            gap={3}
            width={"100%"}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
              pl: 5,
            }}
          >
            <MDTypography variant="h6">
              Meta Keywords <AstrieskIcon />
            </MDTypography>
            <MultiInput
              state={isData?.metaKeywords}
              setState={(e) => setIsData((prev) => ({ ...prev, metaKeywords: e }))}
              addButtonText="Add New Keywords"
              addButtonHandler={(e) => setIsData((prev) => ({ ...prev, metaKeywords: e }))}
              removeButtonHandler={(e) => setIsData((prev) => ({ ...prev, metaKeywords: e }))}
              previousFilledValidate={true}
              required={true}
              // disabled={createUpdateLoading}
            />
          </MDBox>
          <MDBox
            sx={{
              width: "100%",
              justifyContent: "flex-end",
              textAlign: "center",
              display: "flex",
            }}
          >
            {" "}
            <MDButton color={"info"} verdant={"gradient"} type={"submit"}>
              {isOpenUpdate ? `Update Blog` : ` Create Blog`}
            </MDButton>
          </MDBox>
        </MDBox>
      </MDBox>
    </>
  );
};

export default Form;
Form.propTypes = {
  isOpenUpdate: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.any,
  setIsOpenUpdate: PropTypes.any,
};
